import { getRouteApi, useNavigate, type RouteApi } from '@mint/routing';

import { initialSearchParams } from '../constants/tablesConfig.js';

const BASE = '/external-data/import-hub';

export const importHubPaths = {
  performance: `${BASE}/performance/`,
  customMetrics: `${BASE}/custom-metrics`,
  whitelistedEmails: `${BASE}/whitelisted-emails`,
  importsNew: `${BASE}/performance/imports/new`,
  dataFile: `${BASE}/performance/imports/$dataFileId`,
  dataFileUpload: `${BASE}/performance/imports/$dataFileId/upload`,
  dataFileHeaderSelection: `${BASE}/performance/imports/$dataFileId/header-selection`,
  dataFileHeadersMapping: `${BASE}/performance/imports/$dataFileId/headers-mapping`,
  dataFileValidation: `${BASE}/performance/imports/$dataFileId/validation`,
  dataFileDataAssignment: `${BASE}/performance/imports/$dataFileId/data-assignment`,
} as const;

export const useImportHubPaths = () => importHubPaths;

const importHubRoute = getRouteApi('/_secured/external-data/import-hub');
const performanceRoute = getRouteApi(
  '/_secured/external-data/import-hub/performance/',
);
const dataFileRoute = getRouteApi(
  '/_secured/external-data/import-hub/performance/imports/$dataFileId',
);
const dataAssignmentRoute = getRouteApi(
  '/_secured/external-data/import-hub/performance/imports/$dataFileId/data-assignment',
);
const validationRoute = getRouteApi(
  '/_secured/external-data/import-hub/performance/imports/$dataFileId/validation',
);
const whitelistedEmailsRoute = getRouteApi(
  '/_secured/external-data/import-hub/whitelisted-emails',
);
const customMetricsRoute = getRouteApi(
  '/_secured/external-data/import-hub/custom-metrics',
);

export const useImportHubLayoutRouteApi =
  (): RouteApi<'/_secured/external-data/import-hub'> => importHubRoute;

export const usePerformanceRouteApi =
  (): RouteApi<'/_secured/external-data/import-hub/performance/'> =>
    performanceRoute;

export const useDataFileRouteApi =
  (): RouteApi<'/_secured/external-data/import-hub/performance/imports/$dataFileId'> =>
    dataFileRoute;

export const useDataAssignmentRouteApi =
  (): RouteApi<'/_secured/external-data/import-hub/performance/imports/$dataFileId/data-assignment'> =>
    dataAssignmentRoute;

export const useValidationRouteApi =
  (): RouteApi<'/_secured/external-data/import-hub/performance/imports/$dataFileId/validation'> =>
    validationRoute;

export const useWhitelistedEmailsRouteApi =
  (): RouteApi<'/_secured/external-data/import-hub/whitelisted-emails'> =>
    whitelistedEmailsRoute;

export const useCustomMetricsRouteApi =
  (): RouteApi<'/_secured/external-data/import-hub/custom-metrics'> =>
    customMetricsRoute;

export const useImportHubPaginatedSearch = () => {
  const search = useImportHubLayoutRouteApi().useSearch();
  return { ...initialSearchParams, ...search };
};

export const useImportHubNavigate = () => useNavigate();
